export type PlutoPageContext = {
  id: string;
  label: string;
  value: string;
};

const PAGE_LABELS: Readonly<Record<string, string>> = {
  "/": "Companies",
  "/admin/claude-mcp": "Claude MCP settings",
  "/admin/source-health": "Source health",
  "/annual-report/upload": "Annual report upload",
  "/annual-report/view": "Annual reports",
  "/bulk": "Bulk import",
  "/buzz": "Buzz signals",
  "/cli-documentation": "CLI documentation",
  "/domains": "Domains",
  "/heat": "Heat",
  "/import": "Import",
  "/landing": "Bloodline overview",
  "/likely-match": "New locations",
  "/ml": "Movement predictions",
  "/pluto": "Pluto workspace",
  "/score-filter": "Score filters",
  "/scraper-logs": "Scraper logs",
  "/test-helpers": "Test helpers",
  "/tools": "AI tools",
  "/tools/action-title": "Action title tool",
  "/tools/add-use-case": "Add use case tool",
  "/tools/book-review": "Book review tool",
  "/tools/content-suggestions": "Content suggestions tool",
  "/tools/draft-agenda": "Draft agenda tool",
  "/tools/english-translate": "English translation tool",
  "/tools/extract-tonality": "Tonality extraction tool",
  "/tools/grammar-check": "Grammar check tool",
  "/tools/keyword-extract": "Keyword extraction tool",
  "/tools/keyword-intent": "Keyword intent tool",
  "/tools/meta-description": "Meta description tool",
  "/tools/multi-product-title": "Multi-product title tool",
  "/tools/product-title": "Product title tool",
  "/tools/prompt": "Prompt tool",
  "/tools/sales-email-generator": "Sales email generator",
  "/tools/write-article": "Article writing tool",
  "/upload": "Upload",
};

const segmentAfter = (pathname: string, prefix: string): string | null => {
  if (!pathname.startsWith(prefix)) return null;
  const value = pathname.slice(prefix.length).split("/")[0];
  return value ? decodeURIComponent(value) : null;
};

export const getPlutoPageContext = (pathname: string, search: string): PlutoPageContext[] => {
  const companyId = segmentAfter(pathname, "/company/");
  const locationId = segmentAfter(pathname, "/location/");
  const scoreFilterId = segmentAfter(pathname, "/score-filter/");
  const pageLabel = PAGE_LABELS[pathname] ?? "Bloodline page";

  const contexts: PlutoPageContext[] = companyId
    ? [{ id: "company", label: "Company", value: companyId }]
    : locationId
      ? [{ id: "location", label: "Location", value: locationId }]
      : scoreFilterId
        ? [{ id: "score-filter", label: "Score filter", value: scoreFilterId }]
        : [{ id: "page", label: "Page", value: pageLabel }];

  if (search) {
    contexts.push({
      id: "view",
      label: "View",
      value: "Current filters",
    });
  }

  return contexts;
};
